import { isEmpty } from "./general-utils";
import { PageTrackingDetails } from "./types";

export const getPageTrackingDetails = (): PageTrackingDetails => {
  return {
    pageUrl: window?.location?.href || "N/A",
    previousPageUrl: document?.referrer || "N/A",
    pageTitle: document?.title || "N/A"
  };
};

export function buildUserAnalyticsPayload(
  data: any,
  membership: string,
  user_id?: string) {
  const joinValues = (arr?: string[]) => Array.isArray(arr) ? arr.join(", ") : "";

  return {
    user_id,
    membership,
    title: data?.user_title ?? "",
    country: data?.user_addresses_0_country?.value ?? data?.user_addresses_0_country ?? "",
    county: data?.user_addresses_0_county?.value ?? data?.user_addresses_0_county ?? data?.user_addresses_0_state?.value ?? data?.user_addresses_0_state ?? "",
    city: data?.user_addresses_0_city ?? "",
    phone_country: data?.user_countryCodeMobilePhonePrefix ?? "",
    birth_year: data?.dateOfBirth_year ?? "",
    favourite_player: isEmpty(data?.user_interests_favoritePlayerOther)
      ? data?.user_interests_favoritePlayer?.value ?? data?.user_interests_favoritePlayer
      : data?.user_interests_favoritePlayerOther ?? "",
    interested_events_list: joinValues(data?.user_preferences_interestsValues),
    interested_marketing_content: joinValues(data?.user_preferences_championshipValues),
    preferred_marketing_channels: joinValues(data?.user_preferences_channelsValues),
    third_party_subscribed: isThirdPartySubscribed(data?.user_optIns_optedPartnerOffersByEmail)
  };
}

function isThirdPartySubscribed(val: any): boolean {
  if (typeof val === "boolean")
    return val;
  if (val === "optedPartnerOffersByEmail")
    return true;
  if (Array.isArray(val))
    return val.includes("optedPartnerOffersByEmail");
  return false;
}
